import { useHMSRaiseHand } from "../hms";
import { useLivekitRaiseHand } from "../livekit";
import { useProviderHook } from "./useProviderHook";

export const useProviderRaiseHand = peerId =>
  useProviderHook({
    hms: useHMSRaiseHand,
    livekit: useLivekitRaiseHand,
  })(peerId);
